import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RestService {
    apiPath = environment.apiPath; //'http://localhost:3000/admin';
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + sessionStorage.getItem('AUTH') || '',
        }),
    };
    urls = {
        checkAuth: `${this.apiPath}/admin/check-auth`,
        googleAuth: `${this.apiPath}/admin/auth/google`,
        logout: `${this.apiPath}/admin/logout`,
        createSite: `${this.apiPath}/admin/create-site`,
        validateSheet: `${this.apiPath}/admin/validate-sheet`,
        updateSchema: `${this.apiPath}/admin/update-schema`,
        updateConfig: `${this.apiPath}/admin/update-configs`,
        updateCMMS: `${this.apiPath}/admin/update-cmms`,
        createVendor: `${this.apiPath}/admin/create-vendor`,
        getAllVendors: `${this.apiPath}/admin/get-all-vendors`,
        disableVendor: `${this.apiPath}/admin/disable-vendor`,
        generateApiKey: `${this.apiPath}/admin/generate-api-token`,
        deleteVendor: `${this.apiPath}/admin/delete-vendor`,
    }
    constructor(private http: HttpClient) {
    }

    postMethod(url: string, data: any): any {
        return this.http.post(url, data, this.httpOptions);
    }
    getMethod(url: string, data = null): any {
        return this.http.get(url, this.httpOptions);
    }
    putMethod(url: string, data = null): any {
        return this.http.put(url, data, this.httpOptions);
    }
    deleteMethod(url: string): any {
        return this.http.delete(url, this.httpOptions);
    }
}